// 会议相关
let meetInfo = {
  state: {
    rtcClient: null, //云视sdk
    VideoInputDeviceId: null, //视频设备Id
    AudioInputDeviceId: null, //音频设备Id
    AudioOutputDeviceId: null, //音频输入设备id
    meetStatusInfo: null, //会议状态信息, owt返回的
    JoinedList: [], //参会人列表：嘉宾+主播
    layoutData: [], //布局
    selfAudioStatus:null,
    selfVideoStatus:"",
    selfParticipant:null,
    roomId:null,
    groupInfo:null,
    liveSubscription:null
  },
  mutations: {
    SET_RTCCLIENT(state, data) {
      state.rtcClient = data;
    },
    SET_VIDEOINPUTDEVICEID(state, data) {
      state.VideoInputDeviceId = data;
    },
    SET_AUDIOINPUTDEVICEID(state, data) {
      state.AudioInputDeviceId = data;
    },
    SET_AUDIOOUTPUTDEVICEID(state, data) {
      state.AudioOutputDeviceId = data;
    },
    SET_MEETSTATUS_INFO(state, data) {
      state.meetStatusInfo = data;
    },
    SET_JOINEDLIST(state, data) {
      state.JoinedList = data;
    },
    SET_LAYOUTDATA(state, data) {
      state.layoutData = data;
    },
    SET_SELFAUDIOSTATUS(state, data) {
      state.selfAudioStatus = data;
    },
    SET_SELFVIDEOSTATUS(state, data) {
      state.selfVideoStatus = data;
    },
    SET_SELFPARTICIPANT(state, data) {
      window.logger.info({ code: 2006, message: data });
      state.selfParticipant = data;
    },
    SET_ROOMID(state,data){
      state.roomId = data
    },
    SET_GROUPINFO(state,data){
      state.groupInfo = data;
    },
    SET_SHARESUBSCRIPTION(state,data){
      state.liveSubscription = data
    }
  },
};
export default meetInfo;
